import React, { useCallback } from 'react';
import { AnyObject } from 'final-form';
import cn from 'classnames';
import TextTruncate from 'react-text-truncate';

import { useFieldChange } from 'Shared/utils/hooks';
import { createFormField } from 'Shared/utils/createFormField';
import StyledCheckbox from 'Shared/components/Checkboxes/StyledCheckbox/StyledCheckbox';
import WpIcon from 'Wpds/components/icon/WpIcon';

import './ManualWorkspaceField.scss';

function ManualWorkspaceField({ value: workspace, name, index }: AnyObject) {
  const onSelectedChange = useFieldChange(`${name}.selected`);
  const onWorkspaceToCreateOrUpdateChange = useFieldChange('workspaceToCreateOrUpdate');
  const onAddOrUpdateWorkspaceFormOpenChange = useFieldChange('addOrUpdateWorkspaceFormOpen');

  const handleClick = useCallback(() => onSelectedChange(!workspace.selected), [workspace.selected]);

  const handleEditClick = useCallback(
    event => {
      event.stopPropagation();
      onWorkspaceToCreateOrUpdateChange({ ...workspace, index });
      onAddOrUpdateWorkspaceFormOpenChange(true);
    },
    [workspace, index]
  );

  if (!workspace) return null;

  return (
    <div
      className={cn('ManualWorkspaceField d-flex w-100 mb-3 cursor-pointer', {
        'ManualWorkspaceField--selected': workspace.selected,
      })}
      onClick={handleClick}
    >
      <div className="d-flex w-100">
        <StyledCheckbox className="ManualWorkspaceField__checkbox" checked={workspace.selected} onChange={() => null} />
        <div className="mr-2 w-100">
          <div className="ManualWorkspaceField__title">
            <TextTruncate line={2} truncateText="…" text={workspace.fullName} />
          </div>

          {workspace.teammateEmail && (
            <div className="ManualWorkspaceField__info ManualWorkspaceField__info--break-word">
              {workspace.teammateEmail}
            </div>
          )}
        </div>
      </div>
      <div className="ManualWorkspaceField__icon align-items-end pl-2" onClick={handleEditClick}>
        <WpIcon name="edit" />
      </div>
    </div>
  );
}

export default createFormField(ManualWorkspaceField);
